import React, { Component } from 'react';
import { isEmpty } from "lodash";
import { TableRow, TableCell, Button, Box, Grid, Card, TableBody, TableHead, List, ListItem, Typography, Collapse, Accordion, AccordionSummary, AccordionDetails, ListItemText, IconButton, Divider, ListItemIcon } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { TableLayout } from '../../containers/Layout';
import { InputSelectMagasin } from '../../../../../commonModules/interface/form-input-inline';

class ProductStockList extends Component {
    state = {
        stock_type: {value: "AVAILABLE", label: "Disponible"}, 
    }


    render(){
        console.log("[STATE] ProductStockList", this.props, this.state)
        const stockTypeList = [
            {value: "AVAILABLE", label: "Disponible"},
            {value: "PAYG", label: "Pay as you Go"},
            {value: "OUT", label: "Vente directes"},
            {value: "RESERVATION", label: "Réservé"},
            {value: "OCCASION", label: "Occasion"},
            {value: "INSTALLATION", label: "Installation"},
        ]
        return(   
            <Box p={2}>
                <InputSelectMagasin
                    label="Type de Stock"
                    value={this.state.stock_type}
                    onChange={(option) => this.setState({ stock_type: option })}
                    options={stockTypeList.map( field => ({
                        value: field.value,
                        label: field.label,
                        disabled:!!this.state.stock_type == field.value
                    }))}
                />
                <Box p={1}>
                    {!isEmpty(this.props[this.state.stock_type.value]) ?
                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Magasin</TableCell>
                                    {/* <TableCell>Ville</TableCell> */}
                                    <TableCell>Quantité</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.props[this.state.stock_type.value]}
                            </TableBody>
                        </TableLayout>
                    :
                        <Box p={2}>
                            <Alert severity="warning">
                                Pas de stock {this.state.stock_type.label}
                            </Alert>
                        </Box>
                    }
                </Box>
                {/* <Box p={2}>
                    
                    {!isEmpty(this.state.stock) ?
                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Shop</TableCell>
                                    <TableCell>Ville</TableCell>
                                    <TableCell>Quantité</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.stock}
                            </TableBody>
                        </TableLayout>
                    :
                        <div>
                            Article indisponible
                        </div>
                    }
                </Box>
                <Box p={2}>
                    {!isEmpty(this.state.OCCASION) ?
                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Shop</TableCell>
                                    <TableCell>Ville</TableCell>
                                    <TableCell>Quantité</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.OCCASION}
                            </TableBody>
                        </TableLayout>
                    :
                        <div>
                            Article indisponible
                        </div>
                    }
                </Box>
                <Box p={2}>
                    {!isEmpty(this.state.RESERVATION) ?
                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Shop</TableCell>
                                    <TableCell>Quantité</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.RESERVATION}
                            </TableBody>
                        </TableLayout>
                    :
                        <div>
                            Pas de stock
                        </div>
                    }
                </Box>
                <Box p={2}>
                    {!isEmpty(this.state.INSTALLATION) ?
                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Shop</TableCell>
                                    <TableCell>Quantité</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.INSTALLATION}
                            </TableBody>
                        </TableLayout>
                    :
                        <div>
                            Pas de stock
                        </div>
                    }
                </Box>
                <Box p={2}>
                    {!isEmpty(this.state.PAYG) ?
                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Shop</TableCell>
                                    <TableCell>Quantité</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.PAYG}
                            </TableBody>
                        </TableLayout>
                    :
                        <div>
                            Pas de stock
                        </div>
                    }
                </Box>
                <Box p={2}>
                    {!isEmpty(this.state.OUT) ?
                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Shop</TableCell>
                                    <TableCell>Quantité</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.OUT}
                            </TableBody>
                        </TableLayout>
                    :
                        <div>
                            Pas de stock
                        </div>
                    }
                </Box> */}
    
            </Box>
        )
                            
    }
}

export default ProductStockList;